import React, {useCallback, useEffect, useState} from "react";
import Styles from './styles.module.scss'

import Seo from "../../../components/_UI/seo";
import {useTranslation} from "react-i18next";

import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import {getReferrals} from "../../../store/cabinet/action";
import CabinetHello from "../../../components/_UI/cabinetHello";
import CabinetApostolMain from "../../../components/cabinet/cabinetApostolMain";
import CabinetApostolTable from "../../../components/cabinet/cabinetApostolTable";
import CabinetApostolHow from "../../../components/cabinet/cabinetApostolHow";
import CabinetApostolReferral from "../../../components/cabinet/cabinetApostolReferral";
import CabinetApostolRewards from "../../../components/cabinet/cabinetApostolRewards";
import CabinetMainWithdrawModal from "../../../components/cabinet/cabinetMainWithdrawModal";
import CabinetApostolTransfersModal from "../../../components/cabinet/cabinetApostolTransfersModal";




const CabinetApostolPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    // таблица вознаграждений по умолчанию свёрнута, раскрывается кнопкой в левой карточке
    const [isTableOpen, setIsTableOpen] = useState(false);

    const toggleTableHandler = useCallback(() => {
        setIsTableOpen(prev => !prev);
    }, []);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(()=>{
        if (authStatus){
            dispatch(getReferrals());
        }
    },[authStatus, dispatch])

    return (
        <section className={`${Styles.container}`}>
            <Seo title={t('Программа “Апостол”')}/>
            <div className={`${Styles.posWrap}`}>
                <div className={`${Styles.helloWrap} ${Styles.cabinetPC}`}>
                    <CabinetHello
                        title={t('Добро пожаловать в программу “Апостол”')}
                        description={t('Приглашайте участников, развивайте сеть и получайте вознаграждения в $TC')}
                    />
                </div>
                <div className={`${Styles.colLeft}`}>
                    <CabinetApostolMain isTableOpen={isTableOpen} toggleTableHandler={toggleTableHandler}/>
                </div>
                <div className={`${Styles.colCenter}`}>
                    <CabinetApostolTable isOpen={isTableOpen} closeHandler={toggleTableHandler}/>
                    <CabinetApostolHow/>
                </div>
                <div className={`${Styles.colRight}`}>
                    <CabinetApostolReferral/>
                    <CabinetApostolRewards/>
                </div>
            </div>

            {/* та же форма вывода, что и для основного баланса, но по ручкам
                реферального вывода (API 22) */}
            <CabinetMainWithdrawModal isReferral={true}/>
            <CabinetApostolTransfersModal/>
        </section>
    );
};

export default CabinetApostolPage;
